export const MESSAGE = {
    es: {
        //LOGIN
        WELCOME_TOAST: 'Bienvenid@',
        WRONG_CREDENTIALS: 'Credenciales incorrectas',
        LOGIN_ERROR: 'Error al iniciar sesión',
        HI: 'Hola!',
        HI_MESSAGE: 'Ingresa tus credenciales para comenzar',
        EMAIL_PHR: 'Email',
        PASS_PHR: 'Contraseña',
        LOGIN_BTN: 'Entrar',
        LOGIN_REG_TEXT: 'No tienes cuenta?',
        LOGIN_REG_LINK: 'Regístrate',
        LOGIN_REMEMBER: 'Olvidé mi contraseña',
        TO_SEND_MAIL: 'Cambiar contraseña desde mi email',
        MAIL_SENT: 'Mail enviado!',

        //REGISTER
        CHECK_DATA: 'Revisa los datos',
        CHECK_FIELDS: 'Revisa los campos',
        IMPROVE_PASS: 'La contraseña debe tener al menos 4 caracteres',
        REG_ERR: 'Error en el registro',
        HI_REGISTER: 'Primera vez por aquí?',
        PASS2: 'Reingresa la contraseña',
        SET_LAN: 'Elije un idioma',
        REGISTER_BTN: 'Registrarme',
        BACK_BTN: 'Volver',

        //RESET PASSWORD
        EMAIL_NOT_FOUND: 'No hemos podido encontrar el email con el cual ingresaste.',
        CHANGE_PASS: 'Cambiar contraseña',
        ACTUAL_PASS: 'Contraseña actual',
        NEW_PASS: 'Nueva contraseña',
        SAME_PASS: 'Debes ingresar una contraseña diferente',

        //MENU
        MY_ACCOUNT: 'Mi cuenta',
        SETTINGS: 'Ajustes',
        NOTES: 'Notas',
        TASKS: 'Tareas',
        LOGOUT: 'Cerrar sesión',
        REPORT_ISSUE: 'Reportar un problema',
        DARK_MODE: 'Modo nocturno',

        //LEDGER
        L_PAY_TYPES: ['Efectivo', 'Débito', 'TC', 'Transferencia'],
        L_CATEGORIES: ['Varios', 'Mercado', 'Transporte', 'Lujos', 'Gasto Fijo', 'Electro/Deco', 'Salud', 'Indumentaria'],
        L_SAVED: 'Guardado con éxito! Redirigiendo...',
        L_CONNECTED: 'Conectado con éxito! Redirigiendo...',
        L_DISCONNECTED: 'Desconectado con éxito! Redirigiendo...',
        L_TEXT1: 'Si quieres que otras personas participen de tu Libro, compárteles el nombre y contraseña.',
        L_TEXT1_2: 'También puedes conectarte con un Libro existente.',
        L_TEXT2: 'Para comenzar a utilizar CtrlShift, tienes que crear un Libro Contable, donde todos tus gastos serán guardados.',
        L_TEXT2_2: 'Luego, otros usuarios podrán participar de tu Libro, conectándose a través del nombre y contraseña que hayas elegido.',
        L_TEXT2_3: 'También puedes participar de un Libro existente.',
        L_TEXT2_4: 'Todos los datos en esta app estan ecriptados de punta a punta, incluídos los datos de usuario, información de movimientos y ajustes.',
        L_CURRENT: 'Libro Actual',
        L_NEW: 'Nuevo Libro',
        L_NEW_LABEL: 'Nuevo Libro Contable',
        L_CONN: 'Conectar Existente',
        L_NAME: 'Nombre del Libro',
        L_CONN_LABEL: 'Conectar con Libro existente',
        L_CONNECT: 'Conectar',
        L_DISCONNECT: 'Desconectar',

        //ACCOUNT
        NAME: 'Nombre',
        LEDGER: 'Libro actual',
        CONN_LED: 'Crear / Conectar Libro',
        CHANGE_EMAIL: 'Cambiar email',
        CHANGE_NAME: 'Cambiar nombre',

        //SETTINGS
        SAVE_SUCC: 'Guardado con éxito!',
        SET_TITLE: 'Configuración de Movimientos',
        SET_SALARY: 'Saldo Mensual',
        SET_UPDATE: 'Actualizar',
        SET_CAT: 'Categorías',
        SET_CATNAME: 'Nombre...',
        SET_ADD: 'Agregar',
        SET_BUD: 'Presupuesto',
        SET_RES: 'Restante',
        SET_AU: 'Autores',
        SET_PAYTYPES: 'Tipos de Pago',
        DISCARD: 'Descartar',
        SET_SAVE: 'Guardar Cambios',

        //NOTES
        N_DELETED: 'Nota eliminada',
        TO_DELETE: 'Estas a punto de eliminar',
        CANCEL: 'Cancelar',
        CONFIRM: 'Confirmar',
        N_NEW: 'Nueva Nota',
        N_EDIT: 'Editar Nota',
        N_NAME: 'Nombre de la nota...',
        N_DETAIL: 'Detalles...',
        SAVE: 'Guardar',

        //TASKS
        T_SUCC: 'Tarea guardada con éxito!',
        T_REAC: 'Tarea re-activada!',
        T_FIN: 'Tarea finalizada!',
        T_DEL: 'Tarea eliminada',
        DAYS: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
        TOMORROW: 'Mañana',
        T_EDIT: 'Editar tarea',
        T_NEW: 'Nueva tarea',
        T_TITLE: 'Título de la tarea',
        T_ADD_DATE: 'Agregar Fecha',
        T_UNF: 'Sin finalizar',
        T_FIN: 'Finalizadas',
        T_NONE: 'No hay tareas a la vista',
        T_TEXT: 'Comienza creando una nueva',

        //TABLE
        TABLE_HEADERS: ['Fecha', 'Detalle', 'Autor', 'Categoria', 'Tipo', 'Monto'],
        NO_MOVEMENTS: 'No hay movimientos para mostrar',

        //HOME
        MONTHS: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        MOV_DEL: 'Gasto borrado!',
        MOV_ERR: 'Error al borrar',
        MOV_SAVED: 'Gasto guardado!',
        SAVE_ERR: 'Error al guardar',
        DATE: 'Fecha',
        DETAIL: 'Detalle',
        AUTHOR: 'Autor',
        CATEGORY: 'Categoría',
        PAY_TYPE: 'Tipo de pago',
        INSTALLMENT: 'Cuota',
        AMOUNT: 'Monto',
        CSV_NAME: 'Movimientos del Libro',
        CSV_TITLE: 'Extracto de',
        CSV_NONE: 'No hay movimientos para extraer',
        SW_MON: 'Cambiado a Movimientos Mensuales',
        SW_ALL: 'Cambiado a Todos los Movimientos',
        CONN_ERR: 'Error de conexión',
        MOV_INFO: 'Info del pago',
        EXTRA_INFO: 'Pago extraordinario',
        FIAT: '$',
        MOV_DETAIL: 'Detalle del gasto...',
        INSTALLMENTS: 'Cuotas',
        EDIT: 'Editar',
        MOV_NEW: 'Nuevo Gasto',
        SALARY: 'Saldo Actual',
        YES: 'Si',
        NO: 'No',
        MOVEMENTS: 'Gastos',
        MONTHLY: 'Mensual',
        CSV_BTN: 'Extracto',
        MOV_SEARCH: 'Buscar gasto...',
        CAT_REST: 'Resto por categoría',
        CAT_BUD: 'Presupuesto por categoría',
        AN_BAL: 'Balance Anual',
        CAT_EXP: 'Gastos por categoría',
        PAY_TYPES: 'Tipos de Pago',
        AUTHORS: 'Autores',
        USE_LAST_DATE: 'Última fecha',

        //REPORTS
        REPORTS_TITLE: 'Reportar un problema',
        REPORTS_TEXT: 'Te has encontrado con un problema al usar la app? Desde aquí puedes enviarnos lo que ha sucedido. De esta manera nos ayudas a resolverlo rápidamente',
        ISSUE_TITLE: 'Título del problema',
        ISSUE_DESC: 'Describe el problema',
        ISSUE_SAVED: 'Reporte enviado correctamente',
        ISSUE_TX: 'Gracias por tu ayuda :)'
    },

    us: {
        //LOGIN
        WELCOME_TOAST: 'Welcome',
        WRONG_CREDENTIALS: 'Wrong credentials',
        LOGIN_ERROR: 'Failed to login',
        HI: 'Hello!',
        HI_MESSAGE: 'Enter your credentials to get started',
        EMAIL_PHR: 'Email',
        PASS_PHR: 'Password',
        LOGIN_BTN: 'Login',
        LOGIN_REG_TEXT: `Don't have an account?`,
        LOGIN_REG_LINK: 'Register',
        LOGIN_REMEMBER: `I forgot my password`,
        TO_SEND_MAIL: 'Change password from my email',
        MAIL_SENT: 'Email sent!',

        //REGISTER
        CHECK_DATA: 'Check the data',
        CHECK_FIELDS: 'Check the fields',
        IMPROVE_PASS: 'Password must be at least 4 characters',
        REG_ERR: 'Failed to register',
        HI_REGISTER: 'First time here?',
        PASS2: 'Re-enter the password',
        SET_LAN: 'Select Language',
        REGISTER_BTN: 'Register',
        BACK_BTN: 'Back',

        //RESET PASSOWRD
        EMAIL_NOT_FOUND: `We couldn't find the email you signed in with.`,
        CHANGE_PASS: 'Change Password',
        ACTUAL_PASS: 'Current password',
        NEW_PASS: 'New password',
        SAME_PASS: 'You must choose a different password',

        //MENU
        MY_ACCOUNT: 'My account',
        SETTINGS: 'Settings',
        NOTES: 'Notes',
        TASKS: 'Tasks',
        LOGOUT: 'Logout',
        REPORT_ISSUE: 'Report a problem',
        DARK_MODE: 'Toggle Dark Mode',

        //LEDGER
        L_PAY_TYPES: ['Cash', 'Debit', 'Credit Card', 'Transfer'],
        L_CATEGORIES: ['Various', 'Market', 'Transport', 'Luxury', 'Fixed Expense', 'Electro/Deco', 'Health', 'Clothes'],
        L_SAVED: 'Save successfully! Redirecting...',
        L_CONNECTED: 'Connected successfully! Redirecting...',
        L_DISCONNECTED: 'Disconnected successfully! Redirecting...',
        L_TEXT1: 'If you want other people to participate in your Ledger, share the name and password with them.',
        L_TEXT1_2: 'You can also connect with another existing Ledger.',
        L_TEXT2: 'To start using CtrlShift you must create a Ledger, where all your expemses will be saved.',
        L_TEXT2_2: 'Then other people will be able to participate in your Ledger, connecting with the name and password.',
        L_TEXT2_3: 'You can also connect with an existing Ledger.',
        L_TEXT2_4: 'All data in this app is end-to-end encrypted, including user data, movement information and settings.',
        L_CURRENT: 'Current Ledger',
        L_NEW: 'New Book',
        L_NEW_LABEL: 'New Ledger',
        L_CONN: 'Connect Existing',
        L_NAME: 'Book Name',
        L_CONN_LABEL: 'Connect to Existing Ledger',
        L_CONNECT: 'Connect',
        L_DISCONNECT: 'Disconnect',

        //ACCOUNT
        NAME: 'Name',
        LEDGER: 'Current Ledger',
        CONN_LED: 'Create/Connect Ledger',
        CHANGE_EMAIL: 'Change email',
        CHANGE_NAME: 'Change name',

        //SETTINGS
        SAVE_SUCC: 'Saved successfully!',
        SET_TITLE: 'Movement Settings',
        SET_SALARY: 'Monthly Income',
        SET_UPDATE: 'Update',
        SET_CAT: 'Categories',
        SET_CATNAME: 'Name...',
        SET_ADD: 'Add',
        SET_BUD: 'Budget',
        SET_RES: 'Remaining',
        SET_AU: 'Authors',
        SET_PAYTYPES: 'Payment Types',
        DISCARD: 'Discard',
        SET_SAVE: 'Save Changes',

        // NOTES
        N_DELETED: 'Note deleted',
        TO_DELETE: 'You are about to delete',
        CANCEL: 'Cancel',
        CONFIRM: 'Confirm',
        N_NEW: 'New Note',
        N_EDIT: 'Edit Note',
        N_NAME: 'Note name...',
        N_DETAIL: 'Details...',
        SAVE: 'Save',

        //TASKS
        T_SUCC: 'Task saved successfully!',
        T_REAC: 'Task re-activated!',
        T_FIN: 'Task finished!',
        T_DEL: 'Task deleted',
        DAYS: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        TODAY: 'Today',
        YESTERDAY: 'yesterday',
        TOMORROW: 'Tomorrow',
        T_EDIT: 'Edit task',
        T_NEW: 'New task',
        T_TITLE: 'Title of the task',
        T_ADD_DATE: 'Add Date',
        T_UNF: 'Unfinished',
        T_FIN: 'Finished',
        T_NONE: 'There are no tasks in view',
        T_TEXT: 'Start by creating a new one',

        //TABLE
        TABLE_HEADERS: ['Date', 'Detail', 'Author', 'Category', 'Pay Type', 'Amount'],
        NO_MOVEMENTS: 'No expenses to show',

        //HOME
        MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        MOV_DEL: 'Expense deleted!',
        MOV_ERR: 'Error deleting',
        MOV_SAVED: 'Expense saved!',
        SAVE_ERR: 'Error saving',
        DATE: 'Date',
        DETAIL: 'Detail',
        AUTHOR: 'Author',
        CATEGORY: 'Category',
        PAY_TYPE: 'Type of payment',
        INSTALLMENT: 'Installment',
        AMOUNT: 'Amount',
        CSV_NAME: 'Book Moves',
        CSV_TITLE: 'Excerpt from',
        CSV_NONE: 'There are no movements to extract',
        SW_MON: 'Switched to Monthly Expenses',
        SW_ALL: 'Switched to All Moves',
        CONN_ERR: 'Connection error',
        MOV_INFO: 'Payment info',
        EXTRA_INFO: 'Extraordinary payment',
        FIAT: '$',
        MOV_DETAIL: 'Detail of the expense...',
        INSTALLMENTS: 'Installments',
        EDIT: 'Edit',
        MOV_NEW: 'New Expense',
        SALARY: 'Current Balance',
        YES: 'Yes',
        NO: 'No',
        MOVEMENTS: 'Expenses',
        MONTHLY: 'Monthly',
        CSV_BTN: 'Extract',
        MOV_SEARCH: 'Search expense...',
        CAT_REST: 'Rest by category',
        CAT_BUD: 'Budget by category',
        AN_BAL: 'Annual Balance',
        CAT_EXP: 'Expenses by category',
        PAY_TYPES: 'Payment Types',
        AUTHORS: 'Authors',
        USE_LAST_DATE: 'Use last date',

        //REPORTS
        REPORTS_TITLE: 'Report a problem',
        REPORTS_TEXT: 'Did you have a problem while using the app? Did you hit a bug? From here you can send us a report of what has happened, and so you can help us solve it quickly',
        ISSUE_TITLE: 'Title of the issue',
        ISSUE_DESC: 'Describe what happened',
        ISSUE_SAVED: 'Report sent successfully',
        ISSUE_TX: 'Thanks for your help :)'
    },

    en: {
        //LOGIN
        WELCOME_TOAST: 'Welcome',
        WRONG_CREDENTIALS: 'Wrong credentials',
        LOGIN_ERROR: 'Failed to login',
        HI: 'Hello!',
        HI_MESSAGE: 'Enter your credentials to get started',
        EMAIL_PHR: 'Email',
        PASS_PHR: 'Password',
        LOGIN_BTN: 'Login',
        LOGIN_REG_TEXT: `Don't have an account?`,
        LOGIN_REG_LINK: 'Register',
        LOGIN_REMEMBER: `I forgot my password`,
        TO_SEND_MAIL: 'Change password from my email',
        MAIL_SENT: 'Email sent!',

        //REGISTER
        CHECK_DATA: 'Check the data',
        CHECK_FIELDS: 'Check the fields',
        IMPROVE_PASS: 'Password must be at least 4 characters',
        REG_ERR: 'Failed to register',
        HI_REGISTER: 'First time here?',
        PASS2: 'Re-enter the password',
        SET_LAN: 'Select Language',
        REGISTER_BTN: 'Register',
        BACK_BTN: 'Back',

        //RESET PASSOWRD
        EMAIL_NOT_FOUND: `We couldn't find the email you signed in with.`,
        CHANGE_PASS: 'Change Password',
        ACTUAL_PASS: 'Current password',
        NEW_PASS: 'New password',
        SAME_PASS: 'You must choose a different password',

        //MENU
        MY_ACCOUNT: 'My account',
        SETTINGS: 'Settings',
        NOTES: 'Notes',
        TASKS: 'Tasks',
        LOGOUT: 'Logout',
        REPORT_ISSUE: 'Report a problem',
        DARK_MODE: 'Toggle Dark Mode',

        //LEDGER
        L_PAY_TYPES: ['Cash', 'Debit', 'Credit Card', 'Transfer'],
        L_CATEGORIES: ['Various', 'Market', 'Transport', 'Luxury', 'Fixed Expense', 'Electro/Deco', 'Health', 'Clothes'],
        L_SAVED: 'Save successfully! Redirecting...',
        L_CONNECTED: 'Connected successfully! Redirecting...',
        L_DISCONNECTED: 'Disconnected successfully! Redirecting...',
        L_TEXT1: 'If you want other people to participate in your Ledger, share the name and password with them.',
        L_TEXT1_2: 'You can also connect with another existing Ledger.',
        L_TEXT2: 'To start using CtrlShift you must create a Ledger, where all your expenses will be saved.',
        L_TEXT2_2: 'Then other people will be able to participate in your Ledger, connecting with the name and password.',
        L_TEXT2_3: 'You can also connect with an existing Ledger.',
        L_TEXT2_4: 'All data in this app is end-to-end encrypted, including user data, movement information and settings.',
        L_CURRENT: 'Current Ledger',
        L_NEW: 'New Book',
        L_NEW_LABEL: 'New Ledger',
        L_CONN: 'Connect Existing',
        L_NAME: 'Book Name',
        L_CONN_LABEL: 'Connect to Existing Book',
        L_CONNECT: 'Connect',
        L_DISCONNECT: 'Disconnect',

        //ACCOUNT
        NAME: 'Name',
        LEDGER: 'Current Ledger',
        CONN_LED: 'Create/Connect Ledger',
        CHANGE_EMAIL: 'Change email',
        CHANGE_NAME: 'Change name',

        //SETTINGS
        SAVE_SUCC: 'Saved successfully!',
        SET_TITLE: 'Movement Settings',
        SET_SALARY: 'Monthly Income',
        SET_UPDATE: 'Update',
        SET_CAT: 'Categories',
        SET_CATNAME: 'Name...',
        SET_ADD: 'Add',
        SET_BUD: 'Budget',
        SET_RES: 'Remaining',
        SET_AU: 'Authors',
        SET_PAYTYPES: 'Payment Types',
        DISCARD: 'Discard',
        SET_SAVE: 'Save Changes',

        // NOTES
        N_DELETED: 'Note deleted',
        TO_DELETE: 'You are about to delete',
        CANCEL: 'Cancel',
        CONFIRM: 'Confirm',
        N_NEW: 'New Note',
        N_EDIT: 'Edit Note',
        N_NAME: 'Note name...',
        N_DETAIL: 'Details...',
        SAVE: 'Save',

        //TASKS
        T_SUCC: 'Task saved successfully!',
        T_REAC: 'Task re-activated!',
        T_FIN: 'Task finished!',
        T_DEL: 'Task deleted',
        DAYS: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        TODAY: 'Today',
        YESTERDAY: 'yesterday',
        TOMORROW: 'Tomorrow',
        T_EDIT: 'Edit task',
        T_NEW: 'New task',
        T_TITLE: 'Title of the task',
        T_ADD_DATE: 'Add Date',
        T_UNF: 'Unfinished',
        T_FIN: 'Finished',
        T_NONE: 'There are no tasks in view',
        T_TEXT: 'Start by creating a new one',

        //TABLE
        TABLE_HEADERS: ['Date', 'Detail', 'Author', 'Category', 'Pay Type', 'Amount'],
        NO_MOVEMENTS: 'No expenses to show',

        //HOME
        MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        MOV_DEL: 'Expense deleted!',
        MOV_ERR: 'Error deleting',
        MOV_SAVED: 'Expense saved!',
        SAVE_ERR: 'Error saving',
        DATE: 'Date',
        DETAIL: 'Detail',
        AUTHOR: 'Author',
        CATEGORY: 'Category',
        PAY_TYPE: 'Type of payment',
        INSTALLMENT: 'Installment',
        AMOUNT: 'Amount',
        CSV_NAME: 'Book Moves',
        CSV_TITLE: 'Excerpt from',
        CSV_NONE: 'There are no movements to extract',
        SW_MON: 'Switched to Monthly Expenses',
        SW_ALL: 'Switched to All Moves',
        CONN_ERR: 'Connection error',
        MOV_INFO: 'Payment info',
        EXTRA_INFO: 'Extraordinary payment',
        FIAT: '$',
        MOV_DETAIL: 'Detail of the expense...',
        INSTALLMENTS: 'Installments',
        EDIT: 'Edit',
        MOV_NEW: 'New Expense',
        SALARY: 'Current Balance',
        YES: 'Yes',
        NO: 'No',
        MOVEMENTS: 'Expenses',
        MONTHLY: 'Monthly',
        CSV_BTN: 'Extract',
        MOV_SEARCH: 'Search expense...',
        CAT_REST: 'Rest by category',
        CAT_BUD: 'Budget by category',
        AN_BAL: 'Annual Balance',
        CAT_EXP: 'Expenses by category',
        PAY_TYPES: 'Payment Types',
        AUTHORS: 'Authors',
        USE_LAST_DATE: 'Use last date',

        //REPORTS
        REPORTS_TITLE: 'Report a problem',
        REPORTS_TEXT: 'Did you have a problem while using the app? Did you hit a bug? From here you can send us a report of what has happened, and so you can help us solve it quickly',
        ISSUE_TITLE: 'Title of the issue',
        ISSUE_DESC: 'Describe what happened',
        ISSUE_SAVED: 'Report sent successfully',
        ISSUE_TX: 'Thanks for your help :)'
    },

    se: {
        //LOGIN
        WELCOME_TOAST: 'Välkommen',
        WRONG_CREDENTIALS: 'Fel inloggningsuppgifter',
        LOGIN_ERROR: 'Det gick inte att logga in',
        HI: 'hej!',
        HI_MESSAGE: 'Ange dina referenser för att komma igång',
        EMAIL_PHR: 'E-post',
        PASS_PHR: 'Lösenord',
        LOGIN_BTN: 'Enter',
        LOGIN_REG_TEXT: 'Har du inget konto?',
        LOGIN_REG_LINK: 'Registrera',
        LOGIN_REMEMBER: 'Kom ihåg mitt lösenord',
        TO_SEND_MAIL: 'Ändra lösenord från min e-post',
        MAIL_SENT: 'E-post skickat!',

        //REGISTER
        CHECK_DATA: 'Kontrollera data',
        CHECK_FIELDS: 'Kontrollera fälten',
        IMPROVE_PASS: 'Lösenord måste bestå av minst 4 tecken',
        REG_ERR: 'Det gick inte att registrera sig',
        HI_REGISTER: 'Första gången här?',
        PASS2: 'Ange lösenordet igen',
        SET_LAN: 'Välj språk',
        REGISTER_BTN: 'Registrera',
        BACK_BTN: 'Tillbaka',

        //RESET PASSWORD
        EMAIL_NOT_FOUND: 'Vi kunde inte hitta e-postadressen du loggade in med.',
        CHANGE_PASS: 'Ändra lösenord',
        ACTUAL_PASS: 'Nuvarande lösenord',
        NEW_PASS: 'Nytt lösenord',
        SAME_PASS: 'Du måste välja ett annat lösenord',

        //MENU
        MY_ACCOUNT: 'Mitt konto',
        SETTINGS: 'Inställningar',
        NOTES: 'Anteckningar',
        TASKS: 'Uppgifter',
        LOGOUT: 'Logga ut',
        REPORT_ISSUE: 'Rapportera ett problem',
        DARK_MODE: 'Växla mörkt läge',

        //LEDGER
        L_PAY_TYPES: ['Kontanter', 'Debet', 'Kreditkort', 'Överföring'],
        L_CATEGORIES: ['Olika', 'Marknad', 'Transport', 'Lyx', 'Fast utgift', 'Electro/Deco', 'Hälsa', 'Kläder'],
        L_SAVED: 'Spara framgångsrikt! Omdirigerar...',
        L_CONNECTED: 'Ansluten framgångsrikt! Omdirigerar...',
        L_DISCONNECTED: 'Kopplad från! Omdirigerar...',
        L_TEXT1: 'Om du vill att andra ska delta i din Huvudbok, dela namnet och lösenordet med dem.',
        L_TEXT1_2: 'Du kan också ansluta till en annan befintlig Huvudbok.',
        L_TEXT2: 'För att börja använda CtrlShift måste du skapa en reskontra där alla dina utgifter kommer att sparas.',
        L_TEXT2_2: 'Då kommer andra personer att kunna delta i din Huvudbok, ansluta med namn och lösenord.',
        L_TEXT2_3: 'Du kan också ansluta till en befintlig reskontra.',
        L_TEXT2_4: 'All data i den här appen är krypterad från slut till ände, inklusive användardata, rörelseinformation och inställningar.',
        L_CURRENT: 'Aktuell bok',
        L_NEW: 'Ny bok',
        L_NEW_LABEL: 'Ny bokföringsbok',
        L_CONN: 'Anslut befintlig',
        L_NAME: 'Bokens namn',
        L_CONN_LABEL: 'Anslut till befintlig bok',
        L_CONNECT: 'Anslut',
        L_DISCONNECT: 'Koppla ifrån',

        //ACCOUNT
        NAME: 'Namn',
        LEDGER: 'Huvudbok',
        CONN_LED: 'Skapa/anslut bok',
        CHANGE_EMAIL: 'Ändra e-post',
        CHANGE_NAME: 'Ändra namn',

        //SETTINGS
        SAVE_SUCC: 'Sparat framgångsrikt!',
        SET_TITLE: 'Rörelseinställningar',
        SET_SALARY: 'Månadssaldo',
        SET_UPDATE: 'Uppdatera',
        SET_CAT: 'Kategorier',
        SET_CATNAME: 'Namn...',
        SET_ADD: 'Lägg till',
        SET_BUD: 'Budget',
        SET_RES: 'Återstående',
        SET_AU: 'Författare',
        SET_PAYTYPES: 'Betalningstyper',
        DISCARD: 'Kassera',
        SET_SAVE: 'Spara ändringar',

        //NOTES
        N_DELETED: 'Note raderad',
        TO_DELETE: 'Du är på väg att radera',
        CANCEL: 'Cancel',
        CONFIRM: 'Bekräfta',
        N_NEW: 'Ny anteckning',
        N_EDIT: 'Redigera anteckning',
        N_NAME: 'Notera namn...',
        N_DETAIL: 'Detaljer...',
        SAVE: 'Spara',

        //TASKS
        T_SUCC: 'Uppgiften har sparats framgångsrikt!',
        T_REAC: 'Uppgiften återaktiverad!',
        T_FIN: 'Uppgiften avslutad!',
        T_DEL: 'Uppgiften raderad',
        DAYS: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        TODAY: 'Idag',
        YESTERDAY: 'igår',
        TOMORROW: 'I morgon',
        T_EDIT: 'Redigera uppgift',
        T_NEW: 'Ny uppgift',
        T_TITLE: 'Uppgiftens titel',
        T_ADD_DATE: 'Lägg till datum',
        T_UNF: 'Oavslutad',
        T_FIN: 'Färdig',
        T_NONE: 'Det finns inga uppgifter i sikte',
        T_TEXT: 'Börja med att skapa en ny',

        //TABLE
        TABLE_HEADERS: ['Datum', 'Detalj', 'Författare', 'Kategori', 'Lönetyp', 'Belopp'],
        NO_MOVEMENTS: 'Inga utgifter att visa',

        //HOME
        MONTHS: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
        MOV_DEL: 'Utgift raderade!',
        MOV_ERR: 'Fel vid borttagning',
        MOV_SAVED: 'Utgifter sparade!',
        SAVE_ERR: 'Det gick inte att spara',
        DATE: 'Datum',
        DETAIL: 'Detalj',
        AUTHOR: 'Författare',
        CATEGORY: 'Kategori',
        PAY_TYPE: 'Typ av betalning',
        AVTAL: 'Kvota',
        AMOUNT: 'Belopp',
        CSV_NAME: 'Boka flyttar',
        CSV_TITLE: 'Utdrag från',
        CSV_NONE: 'Det finns inga rörelser att extrahera',
        SW_MON: 'Bytt till månatliga utgifter',
        SW_ALL: 'Bytt till alla utgifter',
        CONN_ERR: 'Anslutningsfel',
        MOV_INFO: 'Betalningsinformation',
        EXTRA_INFO: 'Extraordinär betalning',
        FIAT: 'Kr',
        MOV_DETAIL: 'Detaljer om kostnaden...',
        INSTALLMENTS: 'Kvoter',
        EDIT: 'Redigera',
        MOV_NEW: 'Ny utgift',
        SALARY: 'Nuvarande saldo',
        YES: 'Ja',
        NO: 'Nej',
        MOVEMENTS: 'Utgifter',
        MONTHLY: 'Månatlig',
        CSV_BTN: 'Extrahera',
        MOV_SEARCH: 'Sök utgifter...',
        CAT_REST: 'Vila efter kategori',
        CAT_BUD: 'Budgetera efter kategori',
        AN_BAL: 'Årssaldo',
        CAT_EXP: 'Utgifter per kategori',
        PAY_TYPES: 'Betalningstyper',
        AUTHORS: "Författare",

        //REPORTS
        REPORTS_TITLE: 'Rapportera ett problem',
        REPORTS_TEXT: 'Hade du problem när du använde appen? Träffade du en bugg? Härifrån kan du skicka oss en rapport om vad som har hänt, så att du kan hjälpa oss att lösa det snabbt',
        ISSUE_TITLE: 'Ärendens titel',
        ISSUE_DESC: 'Beskriv vad som hände',
        ISSUE_SAVED: 'Rapporten har skickats framgångsrikt',
        ISSUE_TX: 'Tack för din hjälp :)'
    }
}